import RADApplication from '@/Management/RADApplication';
import * as XMLConverter from '@/Utility/XMLConverter';

export function XMLStringToObject(string: string): {} {
    if (string) {
        //string = string.replace(/&#xD;?&#xA;/gm, '\\n');
        let xml = $.parseXML(string);
        let json = XMLConverter.xml2json(xml, '');
        json = json.replace(/(\r\n|\n|\r)/gm, '');
        json = _.unescape(json);
        let object = JSON.parse(json);

        return object;
    }

    return null;
}

export function ObjectToXMLString(object: {}): string {
    let xml = '<?xml version="1.0" encoding="utf-16" ?>' + XMLConverter.json2xml(object, '');
    return xml;
}

export function UpdateDataHandlerURL(url: string): string {
    if (!url) {
        return null;
    }
    return url.replace('$$DATA_HANDLER$$', RADApplication.getInstance().radEnvironmentDataHandler);
}

export default {
    UpdateDataHandlerURL,
    ObjectToXMLString,
    XMLStringToObject
}